export default {"src":"/_next/static/media/failed-icon.22041038.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};